import styled from 'styled-components';

const OverflowContainer = styled.div`
	width: calc(((100% - 600px) / 3) * 2);
	min-height: calc(90vh - 100px);
	margin-right: 20px;
	overflow-y: auto;
`;

const Container = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
`;

const MissingContainer = styled.div`
	margin: 0 20px;
`;

const inlineButton = styled.button`
	appearance: none;
	border: 0;
	padding: 0;
	background-color: rgba(0,0,0,0);
	text-decoration: underline;
	color: #4A90E2;
`;

export {
	OverflowContainer,
	Container,
	MissingContainer,
	inlineButton,
}
